import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const WeavingInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Weaving Section"
    sectionKey="Weaving Section"
    backRoute="/sections/weaving"
  />
);

export default WeavingInternalTransfer;
